import { createContext, useState, useContext, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { checkInventory } from '../components/queries';

const AppContext = createContext();

export function AppProvider({ children }) {

    const [isScrolled, setIsScrolled] = useState(false);

    //setup for stripe
    const [stripePromise, setPromise] = useState(loadStripe(`${process.env.REACT_APP_TOKEN}`))
    const [options, setOptions] = useState({
        clientSecret: null,
    })
    function handleOptions(data) {
        setOptions({
        clientSecret: data,
    })
    }

    //set inventory
    const [inventory, setInventory] = useState([0,0,0,0,0,0,0,0])
    async function handleInventory() {
        const inv = await checkInventory();
        setInventory(inv)
        console.log('current inventory', inv)
    }

    useEffect(() => {
        handleInventory()
    }, [])

    return (
        <AppContext.Provider value={{ 
            isScrolled, setIsScrolled, stripePromise, options, handleOptions, inventory
            }}>
            {children}
        </AppContext.Provider>
    );
}

export function useAppContext() {
    return useContext(AppContext);
}